import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonService } from '../../../shared/common.service';
import { AuthServiceLocal } from '../../auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  loginForm:FormGroup;
  signUpForm:FormGroup
  isCheck:boolean = false;
  isLoading:boolean = false;
  isVerified:boolean= false;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  show: boolean = false;
  isLower: Boolean = true;
  isUpper: boolean = true;
  isLength:boolean = true;
  isSpecial:boolean = true;
  isSecure:boolean =false;

  roleList =[];
  circleList = [];
  countryList =[
    {"name": "Albania", "code": "AL"},
    {"name": "Åland Islands", "code": "AX"},
    {"name": "Algeria", "code": "DZ"},
    {"name": "American Samoa", "code": "AS"},
    {"name": "Andorra", "code": "AD"},
    {"name": "Angola", "code": "AO"},
    {"name": "Anguilla", "code": "AI"},
    {"name": "Antarctica", "code": "AQ"},
    {"name": "Antigua and Barbuda", "code": "AG"},
    {"name": "Argentina", "code": "AR"},
    {"name": "Armenia", "code": "AM"},
    {"name": "Aruba", "code": "AW"},
    {"name": "Australia", "code": "AU"},
    {"name": "Austria", "code": "AT"},
    {"name": "Azerbaijan", "code": "AZ"},
    {"name": "Bahamas (the)", "code": "BS"},
    {"name": "Bahrain", "code": "BH"},
    {"name": "Bangladesh", "code": "BD"},
    {"name": "Barbados", "code": "BB"},
    {"name": "Belarus", "code": "BY"},
    {"name": "Belgium", "code": "BE"},
    {"name": "Belize", "code": "BZ"},
    {"name": "Benin", "code": "BJ"},
    {"name": "Bermuda", "code": "BM"},
    {"name": "Bhutan", "code": "BT"},
    {"name": "Bolivia (Plurinational State of)", "code": "BO"},
    {"name": "Bonaire, Sint Eustatius and Saba", "code": "BQ"},
    {"name": "Bosnia and Herzegovina", "code": "BA"},
    {"name": "Botswana", "code": "BW"},
    {"name": "Bouvet Island", "code": "BV"},
    {"name": "Brazil", "code": "BR"},
    {"name": "British Indian Ocean Territory (the)", "code": "IO"},
    {"name": "Brunei Darussalam", "code": "BN"},
    {"name": "Bulgaria", "code": "BG"},
    {"name": "Burkina Faso", "code": "BF"},
    {"name": "Burundi", "code": "BI"},
    {"name": "Cabo Verde", "code": "CV"},
    {"name": "Cambodia", "code": "KH"},
    {"name": "Cameroon", "code": "CM"},
    {"name": "Canada", "code": "CA"},
    {"name": "Cayman Islands (the)", "code": "KY"},
    {"name": "Central African Republic (the)", "code": "CF"},
    {"name": "Chad", "code": "TD"},
    {"name": "Chile", "code": "CL"},
    {"name": "China", "code": "CN"},
    {"name": "Christmas Island", "code": "CX"},
    {"name": "Cocos (Keeling) Islands (the)", "code": "CC"},
    {"name": "Colombia", "code": "CO"},
    {"name": "Comoros (the)", "code": "KM"},
    {"name": "Congo (the Democratic Republic of the)", "code": "CD"},
    {"name": "Congo (the)", "code": "CG"},
    {"name": "Cook Islands (the)", "code": "CK"},
    {"name": "Costa Rica", "code": "CR"},
    {"name": "Croatia", "code": "HR"},
    {"name": "Cuba", "code": "CU"},
    {"name": "Curaçao", "code": "CW"},
    {"name": "Cyprus", "code": "CY"},
    {"name": "Czechia", "code": "CZ"},
    {"name": "Côte d'Ivoire", "code": "CI"},
    {"name": "Denmark", "code": "DK"},
    {"name": "Djibouti", "code": "DJ"},
    {"name": "Dominica", "code": "DM"},
    {"name": "Dominican Republic (the)", "code": "DO"},
    {"name": "Ecuador", "code": "EC"},
    {"name": "Egypt", "code": "EG"},
    {"name": "El Salvador", "code": "SV"},
    {"name": "Equatorial Guinea", "code": "GQ"},
    {"name": "Eritrea", "code": "ER"},
    {"name": "Estonia", "code": "EE"},
    {"name": "Eswatini", "code": "SZ"},
    {"name": "Ethiopia", "code": "ET"},
    {"name": "Falkland Islands (the) [Malvinas]", "code": "FK"},
    {"name": "Faroe Islands (the)", "code": "FO"},
    {"name": "Fiji", "code": "FJ"},
    {"name": "Finland", "code": "FI"},
    {"name": "France", "code": "FR"},
    {"name": "French Guiana", "code": "GF"},
    {"name": "French Polynesia", "code": "PF"},
    {"name": "French Southern Territories (the)", "code": "TF"},
    {"name": "Gabon", "code": "GA"},
    {"name": "Gambia (the)", "code": "GM"},
    {"name": "Georgia", "code": "GE"},
    {"name": "Germany", "code": "DE"},
    {"name": "Ghana", "code": "GH"},
    {"name": "Gibraltar", "code": "GI"},
    {"name": "Greece", "code": "GR"},
    {"name": "Greenland", "code": "GL"},
    {"name": "Grenada", "code": "GD"},
    {"name": "Guadeloupe", "code": "GP"},
    {"name": "Guam", "code": "GU"},
    {"name": "Guatemala", "code": "GT"},
    {"name": "Guernsey", "code": "GG"},
    {"name": "Guinea", "code": "GN"},
    {"name": "Guinea-Bissau", "code": "GW"},
    {"name": "Guyana", "code": "GY"},
    {"name": "Haiti", "code": "HT"},
    {"name": "Heard Island and McDonald Islands", "code": "HM"},
    {"name": "Holy See (the)", "code": "VA"},
    {"name": "Honduras", "code": "HN"},
    {"name": "Hong Kong", "code": "HK"},
    {"name": "Hungary", "code": "HU"},
    {"name": "Iceland", "code": "IS"},
    {"name": "India", "code": "IN"},
    {"name": "Indonesia", "code": "ID"},
    {"name": "Iran (Islamic Republic of)", "code": "IR"},
    {"name": "Iraq", "code": "IQ"},
    {"name": "Ireland", "code": "IE"},
    {"name": "Isle of Man", "code": "IM"},
    {"name": "Israel", "code": "IL"},
    {"name": "Italy", "code": "IT"},
    {"name": "Jamaica", "code": "JM"},
    {"name": "Japan", "code": "JP"},
    {"name": "Jersey", "code": "JE"},
    {"name": "Jordan", "code": "JO"},
    {"name": "Kazakhstan", "code": "KZ"},
    {"name": "Kenya", "code": "KE"},
    {"name": "Kiribati", "code": "KI"},
    {"name": "Korea (the Democratic People's Republic of)", "code": "KP"},
    {"name": "Korea (the Republic of)", "code": "KR"},
    {"name": "Kuwait", "code": "KW"},
    {"name": "Kyrgyzstan", "code": "KG"},
    {"name": "Lao People's Democratic Republic (the)", "code": "LA"},
    {"name": "Latvia", "code": "LV"},
    {"name": "Lebanon", "code": "LB"},
    {"name": "Lesotho", "code": "LS"},
    {"name": "Liberia", "code": "LR"},
    {"name": "Libya", "code": "LY"},
    {"name": "Liechtenstein", "code": "LI"},
    {"name": "Lithuania", "code": "LT"},
    {"name": "Luxembourg", "code": "LU"},
    {"name": "Macao", "code": "MO"},
    {"name": "Madagascar", "code": "MG"},
    {"name": "Malawi", "code": "MW"},
    {"name": "Malaysia", "code": "MY"},
    {"name": "Maldives", "code": "MV"},
    {"name": "Mali", "code": "ML"},
    {"name": "Malta", "code": "MT"},
    {"name": "Marshall Islands (the)", "code": "MH"},
    {"name": "Martinique", "code": "MQ"},
    {"name": "Mauritania", "code": "MR"},
    {"name": "Mauritius", "code": "MU"},
    {"name": "Mayotte", "code": "YT"},
    {"name": "Mexico", "code": "MX"},
    {"name": "Micronesia (Federated States of)", "code": "FM"},
    {"name": "Moldova (the Republic of)", "code": "MD"},
    {"name": "Monaco", "code": "MC"},
    {"name": "Mongolia", "code": "MN"},
    {"name": "Montenegro", "code": "ME"},
    {"name": "Montserrat", "code": "MS"},
    {"name": "Morocco", "code": "MA"},
    {"name": "Mozambique", "code": "MZ"},
    {"name": "Myanmar", "code": "MM"},
    {"name": "Namibia", "code": "NA"},
    {"name": "Nauru", "code": "NR"},
    {"name": "Nepal", "code": "NP"},
    {"name": "Netherlands (the)", "code": "NL"},
    {"name": "New Caledonia", "code": "NC"},
    {"name": "New Zealand", "code": "NZ"},
    {"name": "Nicaragua", "code": "NI"},
    {"name": "Niger (the)", "code": "NE"},
    {"name": "Nigeria", "code": "NG"},
    {"name": "Niue", "code": "NU"},
    {"name": "Norfolk Island", "code": "NF"},
    {"name": "Northern Mariana Islands (the)", "code": "MP"},
    {"name": "Norway", "code": "NO"},
    {"name": "Oman", "code": "OM"},
    {"name": "Pakistan", "code": "PK"},
    {"name": "Palau", "code": "PW"},
    {"name": "Palestine, State of", "code": "PS"},
    {"name": "Panama", "code": "PA"},
    {"name": "Papua New Guinea", "code": "PG"},
    {"name": "Paraguay", "code": "PY"},
    {"name": "Peru", "code": "PE"},
    {"name": "Philippines (the)", "code": "PH"},
    {"name": "Pitcairn", "code": "PN"},
    {"name": "Poland", "code": "PL"},
    {"name": "Portugal", "code": "PT"},
    {"name": "Puerto Rico", "code": "PR"},
    {"name": "Qatar", "code": "QA"},
    {"name": "Republic of North Macedonia", "code": "MK"},
    {"name": "Romania", "code": "RO"},
    {"name": "Russian Federation (the)", "code": "RU"},
    {"name": "Rwanda", "code": "RW"},
    {"name": "Réunion", "code": "RE"},
    {"name": "Saint Barthélemy", "code": "BL"},
    {"name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH"},
    {"name": "Saint Kitts and Nevis", "code": "KN"},
    {"name": "Saint Lucia", "code": "LC"},
    {"name": "Saint Martin (French part)", "code": "MF"},
    {"name": "Saint Pierre and Miquelon", "code": "PM"},
    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    {"name": "Samoa", "code": "WS"},
    {"name": "San Marino", "code": "SM"},
    {"name": "Sao Tome and Principe", "code": "ST"},
    {"name": "Saudi Arabia", "code": "SA"},
    {"name": "Senegal", "code": "SN"},
    {"name": "Serbia", "code": "RS"},
    {"name": "Seychelles", "code": "SC"},
    {"name": "Sierra Leone", "code": "SL"},
    {"name": "Singapore", "code": "SG"},
    {"name": "Sint Maarten (Dutch part)", "code": "SX"},
    {"name": "Slovakia", "code": "SK"},
    {"name": "Slovenia", "code": "SI"},
    {"name": "Solomon Islands", "code": "SB"},
    {"name": "Somalia", "code": "SO"},
    {"name": "South Africa", "code": "ZA"},
    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    {"name": "South Sudan", "code": "SS"},
    {"name": "Spain", "code": "ES"},
    {"name": "Sri Lanka", "code": "LK"},
    {"name": "Sudan (the)", "code": "SD"},
    {"name": "Suriname", "code": "SR"},
    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    {"name": "Sweden", "code": "SE"},
    {"name": "Switzerland", "code": "CH"},
    {"name": "Syrian Arab Republic", "code": "SY"},
    {"name": "Taiwan (Province of China)", "code": "TW"},
    {"name": "Tajikistan", "code": "TJ"},
    {"name": "Tanzania, United Republic of", "code": "TZ"},
    {"name": "Thailand", "code": "TH"},
    {"name": "Timor-Leste", "code": "TL"},
    {"name": "Togo", "code": "TG"},
    {"name": "Tokelau", "code": "TK"},
    {"name": "Tonga", "code": "TO"},
    {"name": "Trinidad and Tobago", "code": "TT"},
    {"name": "Tunisia", "code": "TN"},
    {"name": "Turkey", "code": "TR"},
    {"name": "Turkmenistan", "code": "TM"},
    {"name": "Turks and Caicos Islands (the)", "code": "TC"},
    {"name": "Tuvalu", "code": "TV"},
    {"name": "Uganda", "code": "UG"},
    {"name": "Ukraine", "code": "UA"},
    {"name": "United Arab Emirates (the)", "code": "AE"},
    {"name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB"},
    {"name": "United States Minor Outlying Islands (the)", "code": "UM"},
    {"name": "United States of America (the)", "code": "US"},
    {"name": "Uruguay", "code": "UY"},
    {"name": "Uzbekistan", "code": "UZ"},
    {"name": "Vanuatu", "code": "VU"},
    {"name": "Venezuela (Bolivarian Republic of)", "code": "VE"},
    {"name": "Viet Nam", "code": "VN"},
    {"name": "Virgin Islands (British)", "code": "VG"},
    {"name": "Virgin Islands (U.S.)", "code": "VI"},
    {"name": "Wallis and Futuna", "code": "WF"},
    {"name": "Western Sahara", "code": "EH"},
    {"name": "Yemen", "code": "YE"},
    {"name": "Zambia", "code": "ZM"},
    {"name": "Zimbabwe", "code": "ZW"}
  ]
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'userRoleId',
    textField: 'roleName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false
  };
  dropdownSettingCountry: IDropdownSettings = {
    singleSelection: true,
    idField: 'code',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false
  };
  dropdownSettingCircle: IDropdownSettings = {
    singleSelection: false,
    idField: 'circleId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false
  };
  roleShow:boolean = false;
  countryShow:boolean = false;
  circlesOfInterestShow:boolean = false;
  projectDetailSign:any;

  constructor(    
    private fb: FormBuilder,
    private authServices: AuthServiceLocal,
    private commonService: CommonService,
    private router: Router,
    private _snackBar: MatSnackBar) { }
    projectDetail:any
  ngOnInit() {
    this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
    this.projectDetailSign = JSON.parse(localStorage.getItem("project_Signup")) || "noemail";
    this.initialiseForms();
    this.getUserRole();
    this.getPubclicCircle();
    this.updateField();
  }
  updateField(){
    this.projectDetailSign[0]['configurations'].forEach(element => {
      if(element['type'] == 'country'){
        this.countryShow = element['isUsed']
      }
      if(element['type'] == 'role'){
        this.roleShow = element['isUsed']
      }
      if(element['type'] == 'circlesOfInterest'){
        this.circlesOfInterestShow = element['isUsed']
      }
      
    });
    if(this.roleShow == false){
      this.signUpForm.controls['roleIds'].setValidators([Validators.nullValidator]);
      this.signUpForm.controls['roleIds'].updateValueAndValidity();
    }
    if(this.countryShow == false){
      this.signUpForm.controls['country'].setValidators([Validators.nullValidator]);
      this.signUpForm.controls['country'].updateValueAndValidity();
    }
    if(this.circlesOfInterestShow == false){
      this.signUpForm.controls['circlesOfInterest'].setValidators([Validators.nullValidator]);
      this.signUpForm.controls['circlesOfInterest'].updateValueAndValidity();
    }
  }
  getUserRole() {
    this.authServices.getUserRole("").subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.roleList = res.data.userRolesList;
        // this.PatchCircle(this.circleDetails)
      } else {
        this.roleList
          = []
      }
    }, err => {
      this.isLoading = false;
    });
  }

  getPubclicCircle() {
    let query = "limit=1000";
    this.authServices.getPublicCircle(query).subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.circleList = res.data.circleList;
        // this.PatchCircle(this.circleDetails)
      } else {
        this.roleList
          = []
      }
    }, err => {
      this.isLoading = false;
    });
  }
  onItemSelectRole(event) {


  }
  onSelectAllRole(event){

  }
  onItemDeSelectRole(event) {

  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      fullName: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["",[Validators.required, Validators.minLength(8)]],
      institution:["", [Validators.required]],
    });
    this.signUpForm = this.fb.group({
      country: [[], [Validators.required]],
      roleIds:[[], [Validators.required]],
      circlesOfInterest :[[], [Validators.required]],
    });
   
  }
  validateEmail() {
    if(this.loginForm.value.email == null || this.loginForm.value.email == "") {
      return null;
    }
    let request  = {
      email:this.loginForm.value.email,
    }
    // this.isLoading = true;
    this.authServices.verifyEmail(request).subscribe((res) => {
     this.isLoading = false;
      if(res['message'] =='Success') {
      this.isVerified = true;
      } 
    }, err => {
      this.isLoading = false;
      this.isVerified = false;
    });
  }
  submitForm() {
   
    if (this.loginForm.valid) {
      let req = this.loginForm.value;
      let circleId =[];
      let roleId = [];
      let country ;
      let data = this.signUpForm.value;
      data.circlesOfInterest.forEach(element => {
        circleId.push(element['circleId'])
        
      });
      data.roleIds.forEach(element => {
        roleId.push(element['userRoleId'])
      });
      if(data.country.length > 0){
        country= data.country[0]['name'];
      }
     req['country']=country;
     req['circlesOfInterestIds']= circleId;
     req['roleIds']= roleId;

      this.isLoading = true;
      this.authServices.SignupUser(req).subscribe (
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            localStorage.setItem('userData',JSON.stringify(res['data']))
            if(res['data']["accessToken"]) {
              this.commonService.setStorage(
                "token",
                res['data']["accessToken"]
              );
            }
            this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
            this.router.navigate([this.projectDetail['loginNavigationLink']]);
          } else {
          }
        },
        err => {
          // Swal.fire({
          //   icon: "error",
          //   title: err.error.data.message
          // });
          this.router.navigate(["signin"]);
         this._snackBar.open(err.error.data.message, "", {
            duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
             panelClass: ["success"],
           });
          this.isLoading = false;
        }
      );


    }


  }
  password() {
    this.show = !this.show;
  }
  
  getPassword() {
    let password = this.loginForm.value.password;

    if(password.length < 2) {
      this.isUpper = true;
      this.isLower = true;
      this.isLength = true;
      this.isSpecial = true;
      return
    }
    if(password.length > 7) {
      this.isLength = true;
    }else {
      this.isLength = false;
    }
    


    if (password.match("[a-z]")) {
      this.isLower = true;
    } else {
      this.isLower = false;
    }
    if (password.match("[a-z]")) {
      this.isLower = true;
    } else {
      this.isLower = false;
    }
    if (password.match("[A-Z]")) {
      this.isUpper = true;
    }
    else {
      this.isUpper = false;
    }
    if(password.match("[#$^%,!&@_\.-]")){
      this.isSpecial = true;
    }else {
      this.isSpecial = false;
    }
    
    if (this.isLower == true && this.isUpper == true && this.isLength == true && this.isSpecial == true) {
      this.isSecure = true;

    } else {
      this.isSecure = false;
    }

  }
  step1:boolean = false;
  navigateStep(){
    this.step1= !this.step1;
  }
  
}
